module.exports = __webpack_public_path__ + "assets/images/pages/unleash/ball-2.png?b4a7ad74";